import { SetBannerAsSeenArgs } from 'types/api/arguments/set-banner-as-seen-args'

import { api } from './api'

export const setBannerAsSeen = ({ type, name }: SetBannerAsSeenArgs) =>
  api.put(`/banners/${type}/seen`, { name })
